export default "/images/vendor/flag-icon-css/flags/1x1/sg.svg?9751741f84e6e5263a407b127b7d782b";